/* eslint-disable import/first */
import React, { useCallback, useRef } from "react";
import { useDropzone } from "react-dropzone";
import clsx from "clsx";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const DragZone = (props) => {
  const {
    imgSrc,
    icon,
    label,
    className,
    acceptedFiles = "application/pdf",
    maxSize = 25000000,
    multiple = false,
    noClick,
    version = 1,
    handleFile,
    maxFiles = 1,
    onDrop,
    onDropRejected,
  } = props;
  const { t } = useTranslation();
  const { getRootProps, getInputProps, open } = useDropzone({
    accept: acceptedFiles,
    maxSize: maxSize,
    onDrop: onDrop || handleFile,
    noClick,
    multiple: multiple,
    noKeyboard: true,
    maxFiles,
    onDropRejected,
  });

  return (
    <React.Fragment>
      <div className="text-muted d-flex justify-content-between">
        {/* <div>
            {t('maxFiles', { maxFiles, count: maxFiles })}
        </div>
        <div>
            {t('maxSizePerFile', { maxSizeInMb: maxSize/1_000_000 })}
          </div>*/}
      </div>
      <div
        className={clsx(`DragZone_Container`, className, `v${version}`)}
        {...getRootProps({})}
      >
        <input {...getInputProps()} enctype="multipart/form-data" />

        <div className="DragZone_Inner_Container">
          {!icon && imgSrc && (
            <img className="DragZone_Image" src={imgSrc} alt={label} />
          )}
          {icon && !imgSrc && (
            <FontAwesomeIcon
              className={`DragZone_Icon`}
              icon="cloud-upload-alt"
            />
          )}
          <p className="DragZone_Photo_Label text-center text-muted">{label}</p>
        </div>
      </div>
    </React.Fragment>
  );
};
export default DragZone;
